export function format_price(price) {
    return (parseInt(price) / 100).toFixed(2)
}
